// extracted by mini-css-extract-plugin
export default {"base":"PrincipalPais_base__Yg7lU","titulo":"PrincipalPais_titulo__yeQTT","contenedorCuadros":"PrincipalPais_contenedorCuadros__qZrwb"};